export default {
  EBWC_BIG_WIN: 15,
  EBWC_MEGA_WIN: 20,
  EBWC_EPIC_WIN: 35,
}
